module.exports = "/_next/static/pages/profile05/c3b3b94596d5dcebf6f62ac6a7a7242a.png";